<template>
  <div>
    Logged in as: <b>{{ user.email }}</b>
    <br />
    Email Verified: <b>{{ emailVerified }}</b>
  </div>
</template>

<script setup>
import { computed } from "vue";

// Props
const props = defineProps({
  user: Object,
});

const emailVerified = computed(() => (props.user.emailVerified ? "Yes" : "No"));
</script>
